import { ThemeOptions } from '@mui/material';
import type {} from '@mui/material/Badge';

// tslint:disable:interface-name
declare module '@mui/material/Badge' {
  interface BadgePropsVariantOverrides {
    boxy: true;
  }
}

export const MuiBadge: ThemeOptions['components']['MuiBadge'] = {
  variants: [
    {
      props: { variant: 'boxy' },
      style: {
        '.MuiBadge-badge': {
          borderRadius: '4px',
          padding: '0 4px',
          minWidth: 'unset'
        }
      }
    }
  ],
  styleOverrides: {
    badge: ({ ownerState, theme }) => {
      // When a badge has no children, reset its positioning styles to allow it to flow inline
      // with sibling elements rather than being absolutely positioned relative to a parent
      const hasChildren = Boolean(ownerState.children);
      return {
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        ...(!hasChildren && {
          position: 'unset',
          top: 'unset',
          right: 'unset',
          transform: 'unset'
        })
      };
    }
  }
};
